module.exports = __webpack_public_path__ + "static/assets/a16ff5830a119789f5bc5d29a42ace64.mp3";